module["exports"] = [
  "##-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/postcode.js
// module id = 1441
// module chunks = 0